export enum ITipoApi {
    GET = 1,
    POST = 2,
    PUT = 3,
    DELETE = 4,
    MAIL = 5,
    OTHER = 6
}